import { render, staticRenderFns } from "./NumberInputConfig.vue?vue&type=template&id=03fd7659&scoped=true"
import script from "./NumberInputConfig.vue?vue&type=script&lang=js"
export * from "./NumberInputConfig.vue?vue&type=script&lang=js"
import style0 from "./NumberInputConfig.vue?vue&type=style&index=0&id=03fd7659&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd7659",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03fd7659')) {
      api.createRecord('03fd7659', component.options)
    } else {
      api.reload('03fd7659', component.options)
    }
    module.hot.accept("./NumberInputConfig.vue?vue&type=template&id=03fd7659&scoped=true", function () {
      api.rerender('03fd7659', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/NumberInputConfig.vue"
export default component.exports